// extracted by mini-css-extract-plugin
module.exports = {"videoClass":"VideosView-module--videoClass--3-FHd","videosWrapper":"VideosView-module--videosWrapper--3xlor"};